<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout row wrap justify-end> </v-layout>
        <v-layout row wrap pa-2>
          <!-- <v-flex lg3 md3 sm12>
            <v-autocomplete
              label="Đầu bao"
              class="input-group--focused"
              :items="prefixBigpackages"
              item-text="name"
              item-value="value"
              v-model="currentItem.PrefixBigpackage"
              :disabled="currentItem.ID > 0"
            ></v-autocomplete>
          </v-flex> -->
          <v-flex lg3 md3 sm12>
            <v-text-field
              label="Biển số xe"
              class="input-group--focused"
              outlined
              dense
              v-model="currentItem.LicensePlate"
            ></v-text-field>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-text-field
              label="Biển số xe (VN)"
              class="input-group--focused"
              outlined
              dense
              v-model="currentItem.LicensePlateVN"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex lg3 md3 sm12>
            <v-select
              label="Người gọi xe"
              class="input-group--focused"
              v-model="currentItem.Caller"
              :items="truck_caller"
              item-text="name"
              item-value="value"
              outlined
              dense
              clearable
            ></v-select>
          </v-flex> -->
          <v-flex lg6 md6 sm12></v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker
              plabel="Ngày xếp xe"
              class="input-group--focused date-picker"
              v-model="orderDate"
              @onChangeDate="orderDate = $event"
            ></mh-date-picker>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker
              plabel="Ngày chuyển xe"
              class="input-group--focused date-picker"
              v-model="tranferDate"
              @onChangeDate="tranferDate = $event"
            ></mh-date-picker>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker
              plabel="Ngày xếp xe"
              class="input-group--focused date-picker"
              v-model="releaseDate"
              @onChangeDate="releaseDate = $event"
            ></mh-date-picker>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker
              plabel="Ngày nhập kho"
              class="input-group--focused date-picker"
              v-model="storeDate"
              @onChangeDate="storeDate = $event"
            ></mh-date-picker>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-2>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng cân"
              v-model="currentItem.Weight"
              :decimal="1"
              class="input-group--focused"
              disabled
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng khối"
              v-model="currentItem.Volume"
              :decimal="2"
              class="input-group--focused"
              disabled
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng mã"
              v-model="currentItem.NumberOfProduct"
              :decimal="0"
              class="input-group--focused"
              disabled
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-select
              label="Trạng thái"
              v-model="currentItem.Status"
              :items="receive_type_list"
              item-text="name"
              item-value="value"
              class="input-group--focused"
              outlined
              dense
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-2>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng chi không thuế"
              v-model="currentItem.WeightCost"
              :decimal="0"
              class="input-group--focused"
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng thuế"
              v-model="currentItem.TaxCost"
              :decimal="0"
              class="input-group--focused"
            ></h-currency-input>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-6>
          <v-flex lg12 md12 sm12>
            <v-layout row wrap justify-end pr-1>
              <v-btn
                class="mx-2 white--text"
                small
                color="blue"
                @click="saveAllProduct()"
                :disabled="!currentItem.ID || currentItem.Status != receive_type.cho_thong_quan_vn"
                >Nhập tất cả</v-btn
              >
              <v-btn
                class="mx-2"
                small
                color="red"
                @click="addDetail"
                :disabled="currentItem.Status >= receive_type.xep_xe"
                ><v-icon color="white">add</v-icon> Mã lẻ</v-btn
              >
              <v-btn
                class="mx-2"
                small
                color="blue"
                @click="addPackage"
                :disabled="currentItem.Status >= receive_type.xep_xe"
                ><v-icon color="white">archive</v-icon> Bao TN</v-btn
              >
            </v-layout>
          </v-flex>
          <v-flex lg12>
            <v-data-table
              :headers="detail_header"
              :items="details"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>
                    <v-chip small :color="item.IsPackage || item.GoodsType == 1 ? '#1976d2' : '#fbc02d'" :text-color="item.IsPackage || item.GoodsType == 1 ? 'white' : 'black'">
                      {{ item.IsPackage ? 'Bao TN' : (item.GoodsType == 1 ? 'TN' : 'Chính ngạch') }}
                    </v-chip>
                    <div>{{ item.UserName }}</div>
                  </td>
                  <td>{{ (item.IsPackage || item.GoodsType == 1) ? '' : item.PartnerName }}</td>
                  <td>{{ item.IsPackage ? 'Bao hàng TN' : (item.GoodsType == 1 ? '' : item.ProductNameCN) }}</td>
                  <!-- <td>{{ item.ProductNameVN }}</td> -->
                  <td>{{ item.SuffixBill }}</td>
                  <td class="text-right">
                    {{ item.Deposit | currency("", 2) }}
                  </td>
                  <!-- <td class="text-right">{{ item.ExchangeRate | currency }}</td> -->
                  <td class="text-right">
                    {{ item.Weight | currency("", 1) }}
                  </td>
                  <td class="text-right">
                    {{ item.Volume | currency("", 3) }}
                  </td>
                  <td class="text-right">
                    <v-edit-dialog v-if="!item.IsPackage" :return-value.sync="item.OrderNumberOfPack" large lazy @save="saveOrderProduct({'TruckID': currentId, 'ProductID': item.ID, 'NumberOfPack': item.OrderNumberOfPack})">
                        <div>{{ item.OrderNumberOfPack | currency }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.OrderNumberOfPack" type="number" step="1" label="Số kiện hàng" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                    <div v-else>{{ item.OrderNumberOfPack | currency }}</div>
                  </td>
                  <td>{{ item.Status | display_value(product_status_list) }}</td>
                  <td class="text-center">
                    <table-action-buttons :actions="getTruckDetailActions(item)" :stacked="false"></table-action-buttons>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogItem" max-width="1300px">
      <v-card>
        <v-card-title>
          <span class="title">Danh sách hàng hóa</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="dialogItem = false"
            >Đóng</v-btn
          >
          <v-btn @click="onSelectDetail"
            >Lưu lại</v-btn
          >
        </v-card-actions>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <hpo-filter
                  :headers="popup_header"
                  :viewName="popupViewName"
                  v-on:applyFilter="applyFilterDetail"
                  v-on:quickFilter="quickFilterDetail"
                ></hpo-filter>
                <v-row v-if="selectedDetail && selectedDetail.length > 0" class="mb-2 ml-0 pa-0">
                    <v-col cols="auto">Các mã đã chọn:</v-col>
                    <v-col cols="auto">
                        <v-chip color="blue" text-color="white" small>
                            <v-icon left small>mdi-package-variant-closed</v-icon>
                            {{ selectedDetail.length | currency }} mã
                        </v-chip>
                    </v-col>
                    <v-col cols="auto">
                        <v-chip color="orange" text-color="white" small>
                            <v-icon left small>mdi-weight-kilogram</v-icon>
                            {{ selectedItemsWeight | currency('', 1) }} kg
                        </v-chip>
                    </v-col>
                    <v-col cols="auto">
                        <v-chip color="green" text-color="white" small>
                            <v-icon left small>mdi-cube-outline</v-icon>
                            {{ selectedItemsVolume | currency('', 3) }} m³
                        </v-chip>
                    </v-col>
                </v-row>
                <v-data-table
                  fixed-header
                  height="450px"
                  :headers="popup_header"
                  :items="popup_items"
                  item-key="ID"
                  disable-pagination
                  hide-default-footer
                  show-select
                  v-model="selectedDetail"
                >
                  <template v-slot:item="{ item, isSelected, select }">
                    <tr :active="isSelected" @click="select(!isSelected)">
                      <td>
                        <v-checkbox
                          primary
                          hide-details
                          :input-value="isSelected"
                        ></v-checkbox>
                      </td>
                      <td>{{ item.UserName }}</td>
                      <td>{{ item.PartnerName }}</td>
                      <td>{{ item.ProductNameCN }}</td>
                      <!-- <td>{{ item.ProductNameVN }}</td> -->
                      <td>{{ item.SuffixBill }}</td>
                      <td class="text-right">
                        {{ item.Deposit | currency("", 2) }}
                      </td>
                      <!-- <td class="text-right">{{ item.ExchangeRate | currency }}</td> -->
                      <td class="text-right">
                        {{ item.Weight | currency("", 1) }}
                      </td>
                      <td class="text-right">
                        {{ item.Volume | currency("", 2) }}
                      </td>
                      <td class="text-right">{{ ((item.NumberOfPack | 0)-(item.NumberOfPackTruck | 0)) | currency }}</td>
                      <td>{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPackage" max-width="1100px">
      <v-card>
        <v-card-title>
          <span class="title">Danh sách Bao hàng TN</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="dialogPackage = false"
            >Đóng</v-btn
          >
          <v-btn @click="onSelectPackage"
            >Lưu lại</v-btn
          >
        </v-card-actions>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <hpo-filter
                  :headers="package_header"
                  :viewName="packageViewName"
                  v-on:applyFilter="applyFilterPackage"
                  v-on:quickFilter="quickFilterPackage"
                ></hpo-filter>
                <v-row v-if="selectedPackage && selectedPackage.length > 0" class="mb-2 ml-0 pa-0">
                    <v-col cols="auto">Các bao đã chọn:</v-col>
                    <v-col cols="auto">
                        <v-chip color="blue" text-color="white" small>
                            <v-icon left small>mdi-archive</v-icon>
                            {{ selectedPackage.length | currency }} bao
                        </v-chip>
                    </v-col>
                    <v-col cols="auto">
                        <v-chip color="orange" text-color="white" small>
                            <v-icon left small>mdi-weight-kilogram</v-icon>
                            {{ selectedPackageWeight | currency('', 1) }} kg
                        </v-chip>
                    </v-col>
                    <v-col cols="auto">
                        <v-chip color="green" text-color="white" small>
                            <v-icon left small>mdi-cube-outline</v-icon>
                            {{ selectedPackageVolume | currency('', 3) }} m³
                        </v-chip>
                    </v-col>
                </v-row>
                <v-data-table
                  v-model="selectedPackage"
                  :headers="package_header"
                  :items="packages_not_transit"
                  item-key="ID"
                  show-select
                  disable-pagination
                  hide-default-footer
                  class="elevation-1 table-modal"
                >
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Filtering from "@/components/Filtering";
import MHDatePicker from "@/components/daterange/MHDatePicker";
import { mapState } from "vuex";
import configs from "@/configs";
import moment from "moment";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";
import _ from "lodash";
export default {
  components: {
    "hpo-filter": Filtering,
    "mh-date-picker": MHDatePicker,
  },
  data() {
    return {
      orderDate: null,
      storeDate: null,
      releaseDate: null,
      tranferDate: null,
      product_status: configs.PRODUCT_STATUS,
      product_status_list: configs.PRODUCT_STATUS_LIST,
      receive_type_list: configs.RECEIVE_TYPE_LIST,
      receive_type: configs.RECEIVE_TYPE,
      truck_caller: configs.TRUCK_CALLER,
      selectedDetail: [],
      selectedPackage: [],
      dialogPackage: false,
      filterPackageConditions: [],
      quickFilterPackageConditions: [],
      detail_header: [
        {
          text: "Mã KH",
          value: "UserName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên đối tác",
          value: "PartnerName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên hàng TQ",
          value: "ProductNameCN",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        // {
        //   text: "Tên hàng VN",
        //   value: "ProductNameVN",
        //   filterable: true,
        //   dataType: configs.DATA_TYPE["String"],
        // },
        {
          text: "Mã vận đơn",
          value: "SuffixBill",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tổng chi (¥)",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        // {
        //   text: "Tỷ giá",
        //   value: "ExchangeRate",
        //   align: "end",
        //   filterable: true,
        //   dataType: configs.DATA_TYPE["Number"],
        // },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tổng kiện",
          value: "OrderNumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.RECEIVE_TYPE_LIST,
          dataType: configs.DATA_TYPE["Enum"],
        },
        {
          text: "",
          value: "",
          align: "center",
          width: "80px",
        },
      ],
      pagination: { ...configs.PAGINATION },
      items_per_page: { ...configs.ITEMS_PER_PAGE },
      filterConditions: [],
      quickFilterConditions: [],
      dialogItem: false,
      popup_header: [
        {
          text: "Mã KH",
          value: "UserName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên đối tác",
          value: "PartnerName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên hàng TQ",
          value: "ProductNameCN",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        // {
        //   text: "Tên hàng VN",
        //   value: "ProductNameVN",
        //   filterable: true,
        //   dataType: configs.DATA_TYPE["String"],
        // },
        {
          text: "Mã vận đơn",
          value: "SuffixBill",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Chi tệ",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        // {
        //   text: "Tỷ giá",
        //   value: "ExchangeRate",
        //   align: "end",
        //   filterable: true,
        //   dataType: configs.DATA_TYPE["Number"],
        // },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tổng kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: this.$t('table_headers.product_type'),
          value: "ProductType",
          filterable: true,
          values: [],
          dataType: configs.DATA_TYPE["Number"],
        },
      ],
      package_header: [
        {
          text: "Mã bao hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tổng kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
      ],
      popupViewName: "truck_popup_list",
      packageViewName: "truck_package_popup_list",
    };
  },
  computed: {
    ...mapState({
      loading: state => state.order.loading,
      currentItem: state => state.order.selected,
      configuration: state => state.configuration.selected,
      details: state => state.product.orderList.data,
      total_details: state => state.product.orderList.total,
      popup_items: state => state.product.all.data,
      packages_not_transit: (state) => state.bigPackage.notTransit,
      product_types: state => state.productType.all.data,
    }),
    prefixBigpackages() {
      if (this.configuration && this.configuration.PrefixBigpackages) {
        const prefixs = JSON.parse(this.configuration.PrefixBigpackages);
        if (prefixs.length) {
          return prefixs.map((a) => {
            return { value: a, name: a };
          });
        }
      }
      return [];
    },
    currentId() {
      return Number(this.$route.params.Pid);
    },
    selectedItemsWeight() {
        return this.selectedDetail.reduce((total, item) => total + (parseFloat(item.Weight) || 0), 0);
    },
    selectedItemsVolume() {
        return this.selectedDetail.reduce((total, item) => total + (parseFloat(item.Volume) || 0), 0);
    },
    selectedItemsNumberOfPack() {
        return this.selectedDetail.reduce((total, item) => total + (parseInt(item.NumberOfPack) || 0), 0);
    },
    selectedPackageWeight() {
        return this.selectedPackage.reduce((total, item) => total + (parseFloat(item.Weight) || 0), 0);
    },
    selectedPackageVolume() {
        return this.selectedPackage.reduce((total, item) => total + (parseFloat(item.Volume) || 0), 0);
    },
  }, 
  watch: {
    currentItem() {
      this.orderDate = this.currentItem.OrderDate
        ? moment.utc(this.currentItem.OrderDate).format('YYYY-MM-DD')
        : null;
      this.storeDate = this.currentItem.StoreDate
        ? moment.utc(this.currentItem.StoreDate).format('YYYY-MM-DD')
        : null;
      this.tranferDate = this.currentItem.TranferDate
        ? moment.utc(this.currentItem.TranferDate).format('YYYY-MM-DD')
        : null;
      this.releaseDate = this.currentItem.ReleaseTruckDate
        ? moment.utc(this.currentItem.ReleaseTruckDate).format('YYYY-MM-DD')
        : null;
    },
    product_types() {
        let header_item = _.find(this.popup_header, { value: "ProductType" });
        if (header_item) {
            header_item.values =
                _.map(this.product_types, (item) => {
                    return {
                        value: item.ID,
                        name: item.Name,
                    };
                }) || [];
        }
    }
  },
  methods: {
    getTruckDetailActions(item) {
      return [
        { label: this.$t('actions.delete'), variant: 'danger-outline', disabled: item.Status != this.product_status.cho_xep_xe && !item.IsPackage, onClick: () => this.deleteDetail(this.currentItem.ID, item.ID, item.IsPackage) }
      ];
    },
    applyFilterDetail(filterConditions) {
      this.filterConditions = filterConditions;
      this.getAvailableProduct();
    },
    quickFilterDetail(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.getAvailableProduct();
    },
    applyFilterPackage(filterConditions) {
      this.filterPackageConditions = filterConditions;
      this.getAvailablePackage();
    },
    quickFilterPackage(filterConditions) {
      this.quickFilterPackageConditions = filterConditions;
      this.getAvailablePackage();
    },
    getDetail() {
      if (!this.currentId) {
        this.$store.commit("order/setDetail", { ID: 0, Status: this.receive_type.cho_xep_xe });
      } else {
        this.$store.dispatch("order/getDetail", this.currentId).then((ret) => {
          ret = ret.data ? ret.data : ret;
          if (_.isEmpty(ret)) {
            sendErrorNotice("Lỗi, không load được dữ liệu.");
          }
        });
        this.$store.dispatch("product/getOrderList", this.currentId);
      }
    },
    getAvailableProduct() {
      var param = {
        filter: [...this.filterConditions],
        quickFilter: this.quickFilterConditions
      };
      param.filter.push({
        column: "Status",
        value: [this.product_status.cho_xep_xe],
        condition: "in",
      });
      param.action = "ton-kho-tq";
      this.$store.dispatch("product/getList", param);
    },
    addDetail() {
      this.dialogItem = true;
      this.getAvailableProduct();
    },
    getAvailablePackage() {
      // Gọi API lấy BigPackage có Status = 0
      var param = {
        filter: [...this.filterPackageConditions],
        quickFilter: this.quickFilterPackageConditions
      };
      param.filter.push({
        column: "Status",
        value: [0], // Đã đóng bao
        condition: "in",
      });
      param.not_tran = true;
      this.$store.dispatch("bigPackage/getListNotTransit", param); // Wait, getListNotTransit doesn't support filter parameters properly in bigPackage.js?
      // Actually we should just fetch it using getList with param.
    },
    addPackage() {
      this.dialogPackage = true;
      this.getAvailablePackage();
    },
    onSelectPackage() {
      if(this.selectedPackage.length === 0) {
        this.dialogPackage = false;
        return;
      }
      let payload = {};
      if(!this.currentId) {
        payload = {
          ...this.currentItem,
          OrderDate: this.orderDate ? moment.utc(this.orderDate).format(configs.SQL_DATE_FORMAT) : null,
          StoreDate: this.storeDate ? moment.utc(this.storeDate).format(configs.SQL_DATE_FORMAT) : null,
          TranferDate: this.tranferDate ? moment.utc(this.tranferDate).format(configs.SQL_DATE_FORMAT) : null,
          ReleaseTruckDate: this.releaseDate ? moment.utc(this.releaseDate).format(configs.SQL_DATE_FORMAT) : null,
        }
      }
      payload.Packages = this.selectedPackage.map(item => item.ID);
      this.$store.dispatch("order/setDetail", {
        data: payload,
        id: this.currentItem.ID
      }).then((ret) => {
        ret = ret.data ? ret.data : ret;
        if (_.isEmpty(ret)) {
          sendErrorNotice("Lỗi, không load được dữ liệu.");
        } else if (!this.currentItem.ID) {
          this.$router.push({
            name: "TruckDetail",
            params: { Pid: ret.ID, title: `Chi tiết xếp xe` },
          });
          this.getDetail();
        } else {
          this.getDetail();
        }
      });
      this.selectedPackage = [];
      this.dialogPackage = false;
    },
    deleteDetail(id, product_id, is_package=false) {
      this.$store.dispatch("orderProduct/setDetail", {
        'data': {'ProductID': product_id, 'ActionType': 'delete', 'IsPackage': is_package},
        'id': id
      });
    },
    onSelectDetail() {
      if(this.selectedDetail.length > 0) {
        let submitList = [];
        let payload = {};
        if(!this.currentId) {
          payload = {
            ...this.currentItem,
            OrderDate: this.orderDate ? moment.utc(this.orderDate).format(configs.SQL_DATE_FORMAT) : null,
            StoreDate: this.storeDate ? moment.utc(this.storeDate).format(configs.SQL_DATE_FORMAT) : null,
            TranferDate: this.tranferDate ? moment.utc(this.tranferDate).format(configs.SQL_DATE_FORMAT) : null,
            ReleaseTruckDate: this.releaseDate ? moment.utc(this.releaseDate).format(configs.SQL_DATE_FORMAT) : null,
          }
        }
        for (const item of this.selectedDetail) {
          submitList.push(item.ID);
        }
        payload.Products = submitList;
        this.$store.dispatch("order/setDetail", {
          data: payload,
          id: this.currentItem.ID
        }).then((ret) => {
          ret = ret.data ? ret.data : ret;
          if (_.isEmpty(ret)) {
            sendErrorNotice("Lỗi, không load được dữ liệu.");
          } else if (!this.currentItem.ID) {
            this.$router.push({
              name: "TruckDetail",
              params: { Pid: ret.ID, title: `Chi tiết xếp xe` },
            });
            this.getDetail();
          }
        });
        this.selectedDetail = [];
        this.dialogItem = false;
      }
    },
    saveData() {
      this.$store.dispatch("order/setDetail", {
        'data': {
          ...this.currentItem, 
          OrderDate: this.orderDate ? moment.utc(this.orderDate).format(configs.SQL_DATE_FORMAT) : null, 
          StoreDate: this.storeDate ? moment.utc(this.storeDate).format(configs.SQL_DATE_FORMAT) : null,
          TranferDate: this.tranferDate ? moment.utc(this.tranferDate).format(configs.SQL_DATE_FORMAT) : null,
          ReleaseTruckDate: this.releaseDate ? moment.utc(this.releaseDate).format(configs.SQL_DATE_FORMAT) : null,
        },
        'id': this.currentItem.ID
      });
      if(!this.currentItem.ID) {
        window.getApp.$emit("APP_NAVIGATE", "TruckList");
      }
    },
    saveOrderProduct(item) {
      this.$store.dispatch("orderProduct/setDetail", {
        'data': {
          ...item
        },
        'id': 99999999
      });
    },
    saveProductItem(item) {
      this.$store.dispatch("product/setDetail", {
        'data': {
          ...item,
          Status: item.ReceiveStatus == this.receive_type.nhap_kho_vn ? this.product_status.nhap_kho_vn : this.product_status.xep_xe
        },
        'id': item.ID
      });
    },
    saveAllProduct() {
      this.$store.dispatch("order/setDetail", {
        'data': {
          ActionType: 'update_child',
          Status: this.product_status.nhap_kho_vn,
          ReceiveStatus: this.receive_type.nhap_kho_vn
        },
        'id': this.currentItem.ID
      });
    },
    exportData() {
      this.$store.dispatch("order/exportDetail", this.currentItem.ID);
    }
  },
  mounted() {
    this.$store.dispatch("configuration/getDetail", 1);
    this.$store.dispatch("productType/getList");
    this.getDetail();
    this.$root.$on("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$on("REQUEST_CREATE_DATA", this.exportData);
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$off("REQUEST_CREATE_DATA", this.exportData);
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
  },
};
</script>
